const EMPTYING_ORDER_ROUTES = {
  create: 'many_emptying_orders',
}

export default EMPTYING_ORDER_ROUTES
